
import { defineComponent, ref } from '@nuxtjs/composition-api'
import get from 'lodash/get'
import { setupTranslationPrefixer } from '~/assets/util'

export default defineComponent({
  props: {
    breadcrumbs: { type: Array, required: true },
    page: { type: Object, required: true },
  },
  setup() {
    const overlayIsOpen = ref(false)
    const toggleOverlay = () => {
      overlayIsOpen.value = !overlayIsOpen.value
    }

    const getVideoId = (url) => {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
      const match = url.match(regExp)
      return match && match[2] ? match[2] : undefined
    }

    return {
      ...setupTranslationPrefixer('DiscoveryDetail'),
      get,
      overlayIsOpen,
      getVideoId,
      toggleOverlay,
    }
  },
  data() {
    return {
      playerVars: {
        autoplay: 1,
        rel: 0,
        modestbranding: 1,
      },
    }
  },
})
